var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timeline-message-players"},_vm._l((_vm.players),function(player,index){return (player)?_c('player-card',{key:player._id,attrs:{"player":player,"backup-crest":_vm.crest,"icon":_vm.iconForPlayer(player, index)}}):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }